import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button, Progress, Popover, Radio } from 'antd'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseCircleFilled,
  CloseOutlined,
  ExclamationOutlined,
  ExclamationCircleTwoTone,
  MinusCircleFilled,
} from '@ant-design/icons'
import '../../css/patient.scss'
import _ from 'lodash'
import moment from 'moment'
import Calendar from 'react-calendar'
import '../../../node_modules/react-calendar/dist/Calendar.css'
import serviceInterface from '../../services/service.interface'
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu'
import AddEvent from './patient.events.add'
import util from '../../util/util'
import RedCross from '../../images/red_cross.svg'
import Play from '../../images/play.svg'
import PatientDayView from './patient.day.view'
import Survey from '../../images/survey_1.svg'
import { useSwipeable } from 'react-swipeable'
import { style } from 'd3'
import { CHART_COLORS } from '../../util/chartPalette'

const PatientCalendar = (props) => {
  const [addEvent, setEvent] = useState(undefined)
  const [visible, setVisible] = useState({})
  var nextMonth = () =>
    props.dayView
      ? props.setDate(moment(props.date).add(props.days, 'd').toDate())
      : props.setDate(moment(props.date).add(1, 'M').toDate())
  var prevMonth = () =>
    props.dayView
      ? props.setDate(moment(props.date).subtract(props.days, 'd').toDate())
      : props.setDate(moment(props.date).subtract(1, 'M').toDate())
  var currentMonth = () => props.setDate(new Date())

  var changeView = (event) => {
    // props.setDayView(!props.dayView);
    props.setDayView(event.target.value)
    props.setDate(
      moment(props.date).isSame(new Date(), 'M')
        ? new Date()
        : moment(props.date).startOf('month').toDate()
    )
  }

  var handleSwipe = useSwipeable({
    onSwipedLeft: nextMonth,
    onSwipedRight: prevMonth,
  })

  var handleClick = (e, data) => setEvent(data)

  var renderEvents = (events, { all, txt }) => {
    return events
      ? events.map((event, i) => {
          var title =
            event.title.length > 15 && !all ? (
              <>
                {event.title.split(' ').slice(0, 2).join(' ')}{' '}
                {!txt && <a style={{ fontSize: '8px' }}>...(more)</a>}
              </>
            ) : (
              event.title
            )
          return !all ? (
            i < 1 ? (
              <b>
                <ExclamationOutlined
                  style={{ color: 'red', fontSize: '9px' }}
                />
                {title}{' '}
                <a a style={{ fontSize: '8px' }}>
                  {txt}
                </a>
              </b>
            ) : null
          ) : (
            <b>
              <br />
              <ExclamationOutlined style={{ color: 'red', fontSize: '10px' }} />
              {event.title}
            </b>
          )
        })
      : null
  }

  var weeklyStatus = (date) => {
    const isSunday = moment(date).weekday() == 0
    if (!moment(date).startOf('week').isSameOrBefore(moment().startOf('week')))
      return
    var exe = _.find(props.patient?.exerciseSchedule?.weeklyactivity_summary, {
      weekdate: moment(date).startOf('week').format('MM/DD/YYYY'),
    })
    var dev = _.find(props.patient?.deviceSchedule?.weeklydevice_summary, {
      weekdate: moment(date).startOf('week').format('MM/DD/YYYY'),
    })
    var feed = _.find(props.patient?.feedbackSchedule?.weeklyfeedschedule, {
      weekdate: moment(date).startOf('week').format('MM/DD/YYYY'),
    })

    if (feed) {
      feed.totaldays = feed.feedback.reduce((a, i) => {
        return (a = a + i.totaldays)
      }, 0)
      feed.completeddays = feed.feedback.reduce((a, i) => {
        return (a = a + i.completeddays)
      }, 0)
    }
    if (dev) {
      dev.totaldays = dev.devices.reduce((a, i) => {
        return (a = a + i.totaldays)
      }, 0)
      dev.completeddays = dev.devices.reduce((a, i) => {
        return (a = a + i.completeddays)
      }, 0)
    }

    if (!exe && !dev) return null
    if (
      (exe?.completeddays == exe?.totaldays &&
        dev?.completeddays == dev?.totaldays) ||
      (!exe && dev?.completeddays == dev?.totaldays) ||
      (exe?.completeddays == exe?.totaldays && !dev)
    ) {
      return isSunday
        ? { exe, dev, status: 'calendarTileComplete left' }
        : { exe, dev, status: 'calendarTileComplete' }
    }
    if (moment(date).startOf('week').isSame(moment().startOf('week'))) return

    if (
      (exe?.completeddays == 0 && dev?.completeddays == 0) ||
      (exe?.completeddays == 0 && !dev) ||
      (dev?.completeddays == 0 && !exe)
    )
      return { exe, dev, status: 'calendarTileInComplete' }

    return { exe, dev, feed, status: 'calendarTilePartial' }
  }
  var handleClose = (index) => {
    var obj = { ...visible }
    obj[index] = false
    setVisible(obj)
  }

  var displayContent = (exe, dev, feed, index) => {
    var mea = [
      'day',
      'days',
      'exercise',
      'exercises',
      'measurement',
      'measurements',
      'questionnaire',
      'questionnaires',
    ]

    var wkday =
      'Week of ' +
      moment(exe?.weekdate || dev?.weekdate || feed?.weekdate).format('D MMM')

    return (
      <div style={{ padding: '10px' }}>
        <CloseOutlined
          onClick={() => handleClose(index)}
          style={{
            cursor: 'pointer',
            position: 'absolute',
            top: 10,
            right: 15,
          }}
        />
        <text style={{ color: CHART_COLORS.lineBlue, paddingtop: '5' }}>
          WEEKLY PROGRESS
        </text>
        <text style={{ padding: '15px' }}>({wkday})</text>

        {exe && (
          <Col>
            {exe && exe?.completeddays >= exe?.totaldays ? (
              <CheckCircleFilled className='popupCompletedcheck' />
            ) : (
              <CheckCircleFilled className='popupNotCompletedcheck' />
            )}
            {
              <text>{`${exe?.completeddays} out of ${exe?.totaldays} ${mea[exe?.totaldays > 1 ? 1 : 0]} ${mea[(exe?.totaldays > 1 ? 1 : 0) + 2]} completed `}</text>
            }
          </Col>
        )}
        {dev && (
          <Col>
            {dev && dev?.completeddays >= dev?.totaldays ? (
              <CheckCircleFilled className='popupCompletedcheck' />
            ) : (
              <CheckCircleFilled className='popupNotCompletedcheck' />
            )}
            {
              <text>{`${dev?.completeddays} out of ${dev?.totaldays} ${mea[(dev?.totaldays > 1 ? 1 : 0) + 4]} completed `}</text>
            }
          </Col>
        )}
        {feed && (
          <Col>
            {feed?.completeddays >= feed?.totaldays ? (
              <CheckCircleFilled className='popupCompletedcheck' />
            ) : (
              <CheckCircleFilled className='popupNotCompletedcheck' />
            )}
            {
              <text>{`${feed?.completeddays} out of ${feed?.totaldays} ${mea[(feed?.totaldays > 1 ? 1 : 0) + 6]} completed `}</text>
            }
          </Col>
        )}
      </div>
    )
  }

  var handleChange = (e, index) => {
    var obj = { ...visible }
    obj[index] = !obj[index]
    setVisible(obj)
  }

  var renderWeeklyStatus = (date) => {
    var currMonth = moment(props.date).startOf('month').month()
    var weekDate = moment(props.date).startOf('month')
    if (moment(weekDate).month() != currMonth)
      return <Col className='tickBox'></Col>
    var weekInMonth = [weeklyStatus(weekDate)]
    weekDate = util.getDate(weekDate.toDate(), 7)
    while (moment(weekDate).startOf('week').month() == currMonth) {
      weekInMonth.push(weeklyStatus(weekDate))
      if (moment(date).startOf('week').isSame(moment(weekDate).startOf('week')))
        break
      weekDate = util.getDate(weekDate, 7)
    }
    return weekInMonth.map((i, index) => {
      if (!i) return <Col className='tickBox'></Col>
      if (i?.status.includes('calendarTileComplete'))
        return (
          <Col className='tickBox boxGreen'>
            <Popover
              placement='topRight'
              overlayClassName='info-pop'
              content={displayContent(i?.exe, i?.dev, i?.feed, index)}
              trigger='click'
              visible={visible[index]}
              onVisibleChange={(e) => handleChange(e, index)}
            >
              <CheckCircleFilled className='weeklyStatus completeWeek' />
            </Popover>
          </Col>
        )
      if (i?.status.includes('calendarTileInComplete'))
        return (
          <Col className='tickBox'>
            <Popover
              placement='topRight'
              overlayClassName='info-pop'
              content={displayContent(i?.exe, i?.dev, i?.feed, index)}
              trigger='click'
              visible={visible[index]}
              onVisibleChange={(e) => handleChange(e, index)}
            >
              <div className='weeklyStatus red-circle circle' />
            </Popover>
          </Col>
        )
      if (i?.status.includes('calendarTilePartial'))
        return (
          <Col className='tickBox'>
            <Popover
              placement='topRight'
              overlayClassName='info-pop'
              content={displayContent(i?.exe, i?.dev, i?.feed, index)}
              trigger='click'
              visible={visible[index]}
              onVisibleChange={(e) => handleChange(e, index)}
            >
              <div className='weeklyStatus yellow-circle circle' />
            </Popover>
          </Col>
        )
    })
  }

  var renderTileContent = ({ activeStartDate, date, view }) => {
    var activitystatus = serviceInterface
      .PatientService()
      .getExerciseStatus({
        date,
        schedules: props.patient?.exerciseSchedule?.exercisedateschedule,
      })
    var measurementstatus = serviceInterface
      .PatientService()
      .getMeasurmentStatus({
        date,
        deviceSchedules: props.patient?.deviceSchedule?.devicedateschedule,
        romTests: props.romTests,
      })
    var id = date.toString()
    var checkDate =
      util.isAfter(new Date(), date) || util.isSame(new Date(), date)
    var events = serviceInterface
      .PatientService()
      .getEvent({ date, schedules: props.patient?.eventSchedule })
    var forms = serviceInterface
      .PatientService()
      .getFeed({
        date,
        schedules: props.patient?.feedbackSchedule?.feedbackdateschedule,
      })
    var formStatus = forms
      ? serviceInterface.PatientService().getFormStatus(forms, date)
      : {}
    // console.log(moment(date).startOf('d').isBefore(moment().startOf('d')),date, "+++++++++++++++++++")
    return (
      <>
        <ContextMenuTrigger id={id}>
          <Row align='top' style={{ height: '100%' }}>
            <Col className={`calendarTile ${weeklyStatus(date)?.status}`}>
              <Row justify='end' className='dateRow'>
                {util.isSame(date, props.patient?.createdAt) && (
                  <img
                    style={{ marginRight: forms ? 2 : 'auto' }}
                    height={19}
                    width={19}
                    src={Play}
                  />
                )}
                {util.isSame(date, props.patient?.surgery?.date) && (
                  <img
                    style={{ marginRight: forms ? 2 : 'auto' }}
                    height={18}
                    width={18}
                    src={RedCross}
                  />
                )}
                {
                  forms && false && (
                    <svg
                      className={
                        formStatus.partial
                          ? 'svgYellow'
                          : formStatus.remaining
                            ? 'formSvg'
                            : formStatus.complete
                              ? 'svgGreen'
                              : 'svgRed'
                      }
                      style={{ marginRight: 'auto' }}
                      height={18}
                      width={18}
                      xmlns='http://www.w3.org/2000/svg'
                      data-name='Layer 1'
                      viewBox='0 0 100 125'
                      x='0px'
                      y='0px'
                    >
                      <title>120all</title>
                      <path d='M73.56,13.32H58.14a8.54,8.54,0,0,0-16.27,0H26.44a11,11,0,0,0-11,11V81.63a11,11,0,0,0,11,11H73.56a11,11,0,0,0,11-11V24.32A11,11,0,0,0,73.56,13.32Zm-30.12,2,.17-.79a6.54,6.54,0,0,1,12.78,0l.17.79h6.19v6.55a3,3,0,0,1-3,3H40.25a3,3,0,0,1-3-3V15.32ZM82.56,81.63a9,9,0,0,1-9,9H26.44a9,9,0,0,1-9-9V24.32a9,9,0,0,1,9-9h8.81v6.55a5,5,0,0,0,5,5h19.5a5,5,0,0,0,5-5V15.32h8.81a9,9,0,0,1,9,9Z' />
                      <path d='M41.16,40.17H29.5a1,1,0,0,0-1,1V52.83a1,1,0,0,0,1,1H41.16a1,1,0,0,0,1-1V41.17A1,1,0,0,0,41.16,40.17Zm-1,11.66H30.5V42.17h9.66Z' />
                      <path d='M70.5,46H49.23a1,1,0,0,0,0,2H70.5a1,1,0,0,0,0-2Z' />
                      <path d='M41.16,64.17H29.5a1,1,0,0,0-1,1V76.83a1,1,0,0,0,1,1H41.16a1,1,0,0,0,1-1V65.17A1,1,0,0,0,41.16,64.17Zm-1,11.66H30.5V66.17h9.66Z' />
                      <path d='M70.5,70H49.23a1,1,0,0,0,0,2H70.5a1,1,0,0,0,0-2Z' />
                    </svg>
                  )
                  /* <img style={{marginRight: 'auto'}} src={Survey} height={18} width={18} className="eventIcon" /> } */
                }
                {util.isSame(new Date(), date) ? (
                  <Col style={{ color: '#20a0ff' }}>
                    <b>{date.getDate()}</b>
                  </Col>
                ) : (
                  <Col> {date.getDate()} </Col>
                )}
              </Row>
              <Row className='eventsRow' hidden={!events}>
                <ul style={{ width: '100%' }}>
                  <Popover
                    content={<ol>{renderEvents(events, { all: true })}</ol>}
                    trigger='hover'
                  >
                    {events.length == 1 && renderEvents(events, { all: false })}
                    {events.length > 1 &&
                      renderEvents(events, { all: false, txt: '...(more)' })}
                  </Popover>
                </ul>
              </Row>
              {/* <Row style={{marginTop: 0}} className="eventsRow" hidden={!forms}>
                            {renderForms(forms)}
                        </Row> */}
              <Row className='calendarStatusRow'>
                {forms && (
                  <Col style={{ width: '100%' }}>
                    <Row style={{ marginBottom: -10 }}>
                      <b>Questionnaire</b>
                    </Row>
                    <Row>
                      <Progress
                        strokeColor={
                          formStatus.partial
                            ? CHART_COLORS.partialYellow
                            : formStatus.complete
                              ? CHART_COLORS.completeGreenSoft
                              : CHART_COLORS.skippedRed
                        }
                        trailColor={
                          checkDate
                            ? CHART_COLORS.remainingGray
                            : CHART_COLORS.skippedRed
                        }
                        formstatus={
                          util.isSame(new Date(), date)
                            ? 'active'
                            : checkDate
                              ? 'normal'
                              : formStatus.percent == 0
                                ? 'exception'
                                : ''
                        }
                        percent={formStatus.percent}
                      />
                    </Row>
                  </Col>
                )}
                <Col style={{ width: '100%' }} hidden={!activitystatus}>
                  <Row style={{ marginBottom: -10 }}>
                    <b>Exercise</b>
                  </Row>
                  <Row>
                    <Progress
                      strokeColor={
                        activitystatus.partial
                          ? CHART_COLORS.partialYellow
                          : activitystatus.complete
                            ? CHART_COLORS.completeGreenSoft
                            : CHART_COLORS.skippedRed
                      }
                      trailColor={
                        checkDate
                          ? CHART_COLORS.remainingGray
                          : CHART_COLORS.skippedRed
                      }
                      activitystatus={
                        util.isSame(new Date(), date)
                          ? 'active'
                          : checkDate
                            ? 'normal'
                            : activitystatus.percent == 0
                              ? 'exception'
                              : ''
                      }
                      percent={activitystatus.percent}
                    />
                  </Row>
                </Col>
                <Col style={{ width: '100%' }} hidden={!measurementstatus}>
                  <Row style={{ marginBottom: -10 }}>
                    <b>Measurement</b>
                  </Row>
                  <Row>
                    <Progress
                      strokeColor={
                        measurementstatus.partial
                          ? CHART_COLORS.partialYellow
                          : measurementstatus.complete
                            ? CHART_COLORS.completeGreenSoft
                            : CHART_COLORS.skippedRed
                      }
                      trailColor={
                        checkDate
                          ? CHART_COLORS.remainingGray
                          : CHART_COLORS.skippedRed
                      }
                      measurementstatus={
                        util.isSame(new Date(), date)
                          ? 'active'
                          : checkDate
                            ? 'normal'
                            : measurementstatus.percent == 0
                              ? 'exception'
                              : ''
                      }
                      percent={measurementstatus.percent}
                    />
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </ContextMenuTrigger>
        <ContextMenu id={id}>
          <MenuItem data={{ date }}>Select</MenuItem>
          {checkDate && (
            <MenuItem data={{ date }} onClick={handleClick}>
              Add Reminder
            </MenuItem>
          )}
        </ContextMenu>
      </>
    )
  }

  return (
    <Col className='calendarContainer'>
      <Row className='calendarActionBox' gutter={20} align='middle'>
        <Col>
          <Row>
            <Button className='arrowBtnLeft' onClick={prevMonth}>
              <ArrowLeftOutlined />
            </Button>
            <Button className='arrowBtnRight' onClick={nextMonth}>
              <ArrowRightOutlined />
            </Button>
          </Row>
        </Col>
        <Col>
          <Button className='todayBtn' onClick={currentMonth}>
            TODAY
          </Button>
        </Col>
        <Col>
          <Radio.Group
            className='calendarStatusRadio'
            buttonStyle='solid'
            onChange={changeView}
            value={props.dayView}
          >
            <Radio.Button value={true}>DAY VIEW</Radio.Button>
            <Radio.Button value={false}>MONTH VIEW</Radio.Button>
          </Radio.Group>
          {/* <Button className="todayBtn" onClick={changeView}>
                       { !props.dayView ? "DAY VIEW" : "MONTH VIEW"}
                    </Button> */}
        </Col>
        <Col className='monthYear'>
          {moment(props.date).format('MMMM YYYY')}
        </Col>
        {/* <Col hidden={!props.dayView} style={{marginLeft: "auto"}}>
                    <Button className="todayBtn" onClick={changeView}>
                       { !props.dayView ? "DAY VIEW" : "MONTH VIEW"}
                    </Button>
                </Col> */}
      </Row>
      <div {...handleSwipe}>
        {!props.dayView ? (
          <Row gutter={16}>
            <Col span={22} style={{ paddingRight: 0 }}>
              <Calendar
                onClickDay={(date) => {
                  props.setDate(date)
                  props.setDayView(true)
                }}
                activeStartDate={moment(props.date).startOf('month').toDate()}
                calendarType={'US'}
                showNavigation={false}
                value={props.date}
                next2Label={null}
                prev2Label={null}
                tileDisabled={({ activeStartDate, date, view }) =>
                  activeStartDate.getMonth() != date.getMonth()
                }
                tileContent={renderTileContent}
                showWeekNumbers={false}
              />{' '}
            </Col>
            <Col span={1} flex={'auto'} style={{ paddingLeft: 0 }}>
              <Row
                justify='space-between'
                align='middle'
                style={{ marginTop: 27.25, height: 110, width: 50 }}
              >
                {renderWeeklyStatus()}
              </Row>
            </Col>
          </Row>
        ) : (
          <PatientDayView date={props.date} days={props.days} />
        )}
      </div>
      <AddEvent
        patientid={props.patient?._id}
        visible={addEvent != undefined}
        onClose={setEvent}
        onSuccess={setEvent}
        date={addEvent?.date}
        hideDate
      />
    </Col>
  )
}

PatientCalendar.propTypes = {
  patient: PropTypes.object,
  date: PropTypes.object,
  setDate: PropTypes.func.isRequired,
  romTests: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    romTests: state.patient.romTests,
  }
}

export default connect(mapStateToProps, null)(PatientCalendar)
